import { Capacitor } from '@capacitor/core';
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';

import { scheduleScrollFocusedInputIntoView } from '../scroll-focused-input-into-view/scroll-focused-input-into-view';

const KEYBOARD_INSET_EXTRA = 32;

export async function setupNativeKeyboard(): Promise<() => void> {
  if (!Capacitor.isNativePlatform()) {
    return () => undefined;
  }

  await Keyboard.setResizeMode({ mode: KeyboardResize.Body });

  const showListener = await Keyboard.addListener('keyboardDidShow', (info) => {
    document.documentElement.style.setProperty(
      '--keyboard-inset',
      `${info.keyboardHeight + KEYBOARD_INSET_EXTRA}px`
    );
    scheduleScrollFocusedInputIntoView();
  });

  const hideListener = await Keyboard.addListener('keyboardDidHide', () => {
    document.documentElement.style.removeProperty('--keyboard-inset');
  });

  return () => {
    showListener.remove();
    hideListener.remove();
    document.documentElement.style.removeProperty('--keyboard-inset');
  };
}
